"use client"

import { useEffect } from "react"
import { resolveDesignSystem } from "@repo/types"
import { usePlatformStatus } from "../../hooks/api/platform/use-platform"
import { applyDesignSystem, readCachedDesignSystem } from "./design-system.helpers"

if (typeof document !== "undefined") applyDesignSystem(readCachedDesignSystem())

/** Applique le système de design choisi dans /superadmin (public : fonctionne aussi sur la page de connexion). */
export function DesignSystemApplier() {
  const { data } = usePlatformStatus()
  const designSystem = data ? resolveDesignSystem(data.designSystem) : undefined

  useEffect(() => {
    if (designSystem) applyDesignSystem(designSystem)
  }, [designSystem])

  return null
}
